interface Props {
	width?: string;
	height?: string;
}

const CardIconActive = ({ width = '25', height = '19' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_4992_14953)">
			<rect width="25" height="18" transform="translate(0 0.699219)" fill="white" />
			<path
				d="M23.7984 18.6992H1.20157C0.539189 18.6992 0 18.1593 0 17.496V1.90244C0 1.23915 0.539189 0.699219 1.20157 0.699219H23.7984C24.4608 0.699219 25 1.23915 25 1.90244V17.496C25 18.1593 24.4608 18.6992 23.7984 18.6992Z"
				fill="#60A5FA"
			/>
			<path
				d="M8.62101 13.7992H3.34516C3.06039 13.7992 2.83008 13.5685 2.83008 13.2834C2.83008 12.9982 3.06039 12.7676 3.34516 12.7676H8.62101C8.90578 12.7676 9.1361 12.9982 9.1361 13.2834C9.1361 13.5685 8.90578 13.7992 8.62101 13.7992Z"
				fill="white"
			/>
			<path
				d="M8.62101 15.6976H3.34516C3.06039 15.6976 2.83008 15.467 2.83008 15.1818C2.83008 14.8966 3.06039 14.666 3.34516 14.666H8.62101C8.90578 14.666 9.1361 14.8966 9.1361 15.1818C9.1361 15.467 8.90578 15.6976 8.62101 15.6976Z"
				fill="white"
			/>
			<rect y="4.69922" width="25" height="3" fill="#ADB5BD" />
		</g>
		<defs>
			<clipPath id="clip0_4992_14953">
				<rect width="25" height="18" fill="white" transform="translate(0 0.699219)" />
			</clipPath>
		</defs>
	</svg>
);

export default CardIconActive;
